import { useQuery } from "@tanstack/react-query";
import { getContentBlockerTemplateBy } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Read service template by ID via RCB ContentBlocker API.
 */ function useContentBlockerTemplateById(id) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.getContentBlockerById(id), ({ signal })=>getContentBlockerTemplateBy({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                id
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: !!id
    });
}
/**
 * Read service template by ID via RCB ContentBlocker API.
 */ function useContentBlockerTemplateByIdentifier(identifier) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.getContentBlockerByIdentifier(identifier), ({ signal })=>getContentBlockerTemplateBy({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                identifier
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: !!identifier
    });
}
export { useContentBlockerTemplateById, useContentBlockerTemplateByIdentifier };
